import Login from "../screens/login/login";
import Warehouses from "../screens/warehouses/warehouses";
import Tablestorage from "../screens/tablestorage/tablestorage";
import Config from "../screens/config/config";




export const rutas=[
    {ruta: '/Login', component: <Login/>},
    {ruta: '/Warehouses', component: <Warehouses/>},
    // {ruta: '/tablestorage', component: <Tablestorage/>},
    {ruta: '/tablestorage/:almacenId', component: <Tablestorage/>},
    {ruta: '/Configuracion', component: <Config/>}
    
    
   

];

